export const Types = {
    GET_AM_TASKS_DETAIL_BY_ID: "GET_AM_TASKS_DETAIL_BY_ID",
    SET_AM_TASKS_DETAIL_BY_ID: " SET_AM_TASKS_DETAIL_BY_ID",
    GET_SAME_LEVEL_LIST_BY_ID: " GET_SAME_LEVEL_LIST_BY_ID",
    SET_SAME_LEVEL_LIST_BY_ID: "SET_SAME_LEVEL_LIST_BY_ID",
    GET_BREAK_DOWN_ROOT_CAUSE: "GET_BREAK_DOWN_ROOT_CAUSE",
    SET_BREAK_DOWN_ROOT_CAUSE: "SET_BREAK_DOWN_ROOT_CAUSE",

    GET_BREAK_DOWN_REASON_GROUP_LIST: "GET_BREAK_DOWN_REASON_GROUP_LIST",
    SET_BREAK_DOWN_REASON_GROUP_LIST: "SET_BREAK_DOWN_REASON_GROUP_LIST",
    GET_BREAK_DOWN_Effect_LIST: "GET_BREAK_DOWN_Effect_LIST",
    SET_BREAK_DOWN_Effect_LIST: "SET_BREAK_DOWN_Effect_LIST",
    GET_TECHNICAL_LIST_BY_POOL_ID: " GET_TECHNICAL_LIST_BY_POOL_ID",
    SET_TECHNICAL_LIST_BY_POOL_ID: " SET_TECHNICAL_LIST_BY_POOL_ID",
    PLAN_MAINTENANCE_ASSIGN_TASK: " PLAN_MAINTENANCE_ASSIGN_TASK",
    SET_AUTONOMOUS_MAINTENANCE_ASSIGN_TASK: " SET_AUTONOMOUS_MAINTENANCE_ASSIGN_TASK",
    PLAN_MAINTENANCE_PLAY_CLOSE: "PLAN_MAINTENANCE_PLAY_CLOSE",
    SET_PLAN_MAINTENANCE_PLAY_CLOSE: "SET_PLAN_MAINTENANCE_PLAY_CLOSE",
    GET_AUTONOMOUS_MAINTENANCE_PLAY_START: "GET_AUTONOMOUS_MAINTENANCE_PLAY_START",
    SET_AUTONOMOUS_MAINTENANCE_PLAY_START: "SET_AUTONOMOUS_MAINTENANCE_PLAY_START",
    SET_AUTONOMOUS_MAINTENANCE_CLOSE_COMPLETE: "SET_AUTONOMOUS_MAINTENANCE_CLOSE_COMPLETE",
    AUTONOMOUS_MAINTENANCE_CLOSE_COMPLETE: "AUTONOMOUS_MAINTENANCE_CLOSE_COMPLETE",
    AUTONOMOUS_MAINTENANCE_PAUSE: "AUTONOMOUS_MAINTENANCE_PAUSE",
    SET_AUTONOMOUS_MAINTENANCE_PAUSE: "SET_AUTONOMOUS_MAINTENANCE_PAUSE",
    SET_AUTONOMOUS_MAINTENANCE_UPDATE_TASK: "SET_AUTONOMOUS_MAINTENANCE_UPDATE_TASK",
    AUTONOMOUS_MAINTENANCE_UPDATE_TASK: "AUTONOMOUS_MAINTENANCE_UPDATE_TASK",
    ADD_TECHNICIANS: "ADD_TECHNICIANS",
    SET_ADD_TECHNICIANS: "SET_ADD_TECHNICIANS",
    AUTONOMOUS_MAINTENANCE_SAVE: "AUTONOMOUS_MAINTENANCE_SAVE",
    SET_AUTONOMOUS_MAINTENANCE_SAVE: "SET_AUTONOMOUS_MAINTENANCE_SAVE",

    GET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST: "GET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST",
    SET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST: "SET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST",

    GET_BREAK_DOWN_REASON_DETAIL: "GET_BREAK_DOWN_REASON_DETAIL",
    SET_BREAK_DOWN_REASON_DETAIL: "SET_BREAK_DOWN_REASON_DETAIL",

    GET_AUTONOMOUS_FILES: "GET_AUTONOMOUS_FILES",
    SET_AUTONOMOUS_FILES: "SET_AUTONOMOUS_FILES",

    ADD_AUTONOMOUS_FILES: "ADD_AUTONOMOUS_FILES",

    MAINTENANCE_PAUSE_REASON: "MAINTENANCE_PAUSE_REASON",
    SET_MAINTENANCE_PAUSE_REASON: "SET_MAINTENANCE_PAUSE_REASON",

    GET_TRACK_HISTORY_BY_ID: "GET_TRACK_HISTORY_BY_ID",
    SET_GET_TRACK_HISTORY_BY_ID: "SET_GET_TRACK_HISTORY_BY_ID",

    DELEET_TASK: "DELEET_TASK",
    SET_DELEET_TASK: "SET_DELEET_TASK",

    SHOW_SNACK_MESSAGE_FOR_AUTONOMOUS_DETAIL: "SHOW_SNACK_MESSAGE_FOR_AUTONOMOUS_DETAIL",

    AUTONOMOUS_DETAIL_INITIAL_STATE_NULL: "AUTONOMOUS_DETAIL_INITIAL_STATE_NULL",

    DELETE_AUTONOMOUS_FILES: "DELETE_AUTONOMOUS_FILES",
};

export const autonomousDetailNull = () => ({
    type: Types.AUTONOMOUS_DETAIL_INITIAL_STATE_NULL,
});

export const deleteTask = (payload) => ({
    type: Types.DELEET_TASK,
    payload,
});
export const setDeleteTask = (payload) => ({
    type: Types.SET_DELEET_TASK,
    payload,
});

export const saveTask = (payload) => ({
    type: Types.AUTONOMOUS_MAINTENANCE_SAVE,
    payload,
});
export const setSaveTask = (payload) => ({
    type: Types.SET_AUTONOMOUS_MAINTENANCE_SAVE,
    payload,
});
export const getTaskHistoryById = (payload) => ({
    type: Types.GET_TRACK_HISTORY_BY_ID,
    payload,
});
export const setTaskHistoryById = (payload) => ({
    type: Types.SET_GET_TRACK_HISTORY_BY_ID,
    payload,
});
export const MaintenancePauseReason = (payload) => ({
    type: Types.MAINTENANCE_PAUSE_REASON,
    payload,
});
export const setMaintenancePauseReason = (payload) => ({
    type: Types.SET_MAINTENANCE_PAUSE_REASON,
    payload,
});

export const getAutonomousFiles = (payload) => ({
    type: Types.GET_AUTONOMOUS_FILES,
    payload,
});
export const setAutonomousFiles = (payload) => ({
    type: Types.SET_AUTONOMOUS_FILES,
    payload,
});

export const addAutonomousFiles = (payload) => ({
    type: Types.ADD_AUTONOMOUS_FILES,
    payload,
});

export const BreakdownReasonDetail = (payload) => ({
    type: Types.GET_BREAK_DOWN_REASON_DETAIL,
    payload,
});
export const setBreakdownReasonDetail = (payload) => ({
    type: Types.SET_BREAK_DOWN_REASON_DETAIL,
    payload,
});

export const BreakdownReasonPlaceByGroupId = (payload) => ({
    type: Types.GET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST,
    payload,
});
export const setBreakdownReasonPlaceByGroupId = (payload) => ({
    type: Types.SET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST,
    payload,
});

export const AddTechnician = (payload) => ({
    type: Types.ADD_TECHNICIANS,
    payload,
});
export const setAddTechnician = (payload) => ({
    type: Types.SET_ADD_TECHNICIANS,
    payload,
});

export const autonomousMaintenanceUpdateTask = (payload) => ({
    type: Types.AUTONOMOUS_MAINTENANCE_UPDATE_TASK,
    payload,
});
export const setautonomousMaintenanceUpdateTask = (payload) => ({
    type: Types.SET_AUTONOMOUS_MAINTENANCE_UPDATE_TASK,
    payload,
});

export const setautonomousMaintenancePause = (payload) => ({
    type: Types.SET_AUTONOMOUS_MAINTENANCE_PAUSE,
    payload,
});

export const autonomousMaintenancePause = (payload) => ({
    type: Types.AUTONOMOUS_MAINTENANCE_PAUSE,
    payload,
});

export const setAutonomousMaintenanceCloaseComplete = (payload) => ({
    type: Types.SET_AUTONOMOUS_MAINTENANCE_CLOSE_COMPLETE,
    payload,
});

export const autonomousMaintenanceCloaseComplete = (payload) => ({
    type: Types.AUTONOMOUS_MAINTENANCE_CLOSE_COMPLETE,
    payload,
});

export const setStartAutonomousMaintenance = (payload) => ({
    type: Types.SET_AUTONOMOUS_MAINTENANCE_PLAY_START,
    payload,
});

export const startAutonomousMaintenance = (payload) => ({
    type: Types.GET_AUTONOMOUS_MAINTENANCE_PLAY_START,
    payload,
});

export const setAutonomousMaintenancePlayOrClose = (payload) => ({
    type: Types.SET_PLAN_MAINTENANCE_PLAY_CLOSE,
    payload,
});

export const autonomousMaintenancePlayOrClose = (payload) => ({
    type: Types.PLAN_MAINTENANCE_PLAY_CLOSE,
    payload,
});
export const autonomousMaintenanceAssign = (payload) => ({
    type: Types.PLAN_MAINTENANCE_ASSIGN_TASK,
    payload,
});
export const setAutonomousMaintenanceAssign = (payload) => ({
    type: Types.SET_AUTONOMOUS_MAINTENANCE_ASSIGN_TASK,
    payload,
});
export const getTechnicianListByPoolId = (payload) => ({
    type: Types.GET_TECHNICAL_LIST_BY_POOL_ID,
    payload,
});
export const setTechnicianListByPoolId = (payload) => ({
    type: Types.SET_TECHNICAL_LIST_BY_POOL_ID,
    payload,
});
export const getBreakdownEffectList = (payload) => ({
    type: Types.GET_BREAK_DOWN_Effect_LIST,
    payload,
});
export const setBreakdownEffectList = (payload) => ({
    type: Types.SET_BREAK_DOWN_Effect_LIST,
    payload,
});
export const getBreakdownReasonGroupList = (payload) => ({
    type: Types.GET_BREAK_DOWN_REASON_GROUP_LIST,
    payload,
});
export const setBreakdownReasonGroupList = (payload) => ({
    type: Types.SET_BREAK_DOWN_REASON_GROUP_LIST,
    payload,
});

export const getbreakdownRootCause = (payload) => ({
    type: Types.GET_BREAK_DOWN_ROOT_CAUSE,
    payload,
});

export const setbreakdownRootCause = (payload) => ({
    type: Types.SET_BREAK_DOWN_ROOT_CAUSE,
    payload,
});

export const getSameLevelListById = (payload) => ({
    type: Types.GET_SAME_LEVEL_LIST_BY_ID,
    payload,
});
export const setSameLevelListById = (payload) => ({
    type: Types.SET_SAME_LEVEL_LIST_BY_ID,
    payload,
});
export const getTaskDetailById = (payload) => ({
    type: Types.GET_AM_TASKS_DETAIL_BY_ID,
    payload,
});

export const setTaskDetailById = (payload) => ({
    type: Types.SET_AM_TASKS_DETAIL_BY_ID,
    payload,
});

export const showSnackMessage = (payload) => ({
    type: Types.SHOW_SNACK_MESSAGE_FOR_AUTONOMOUS_DETAIL,
    payload,
});

export const deleteAutonomousFiles = (payload) => ({
    type: Types.DELETE_AUTONOMOUS_FILES,
    payload,
});
